export const TractorMake = [
  'American',
  'Artis',
  'Autocar',
  'Bens',
  'Blue Bird',
  'Brockway',
  'Bucyrus Erie',
  'Cameron',
  'Cascadia',
  'Caterpillar',
  'Chevrolet',
  'Diamond Reo',
  'Dina',
  'Dodge',
  'Falcon',
  'Ford',
  'Freightliner',
  'GMC',
  'Grove (Crane)',
  'Hino',
  'Hubbard',
  'IHC',
  'Ingersoll Rand',
  'International',
  'International Harvester',
  'Isuzu',
  'Kenworth',
  'Lanco',
  'Liebherr',
  'Link',
  'Linkbelt',
  'Lion',
  'Lorain',
  'Mack',
  'Magnum',
  'Marmon',
  'Mercedes',
  'Mitsubishi',
  'Navistar',
  'New Flyer',
  'P&B',
  'Peterbilt',
  'Pettibone',
  'Pierce',
  'Prevost',
  'Rebel',
  'Scania',
  'Service King',
  'Spartan',
  'Sterling',
  'T880',
  'Tadano',
  'Taylor',
  'Terberg',
  'Terex',
  'Thomas',
  'Toyota',
  'Tractor',
  'Unknown',
  'Vanhool',
  'Volvo',
  'Western Star',
  'White',
] as const;
